import React                from "react";
import {MaybeHasChildren}   from "./@types";
// slot for custom element
export const Footer: React.FC<MaybeHasChildren> = () => null;
